import CodeParser from "codice-fiscale-js"
import dayjs from "dayjs"

export default function getAgeFromFiscalCode(code) {
    const codeParser = new CodeParser(code)

    const dayJsBirth = dayjs(codeParser.birthday)

    const dayJSToday = dayjs()

    const age = dayJSToday.diff(dayJsBirth, "year")

    return age
}

export function toLoginWithSuccessRedirect(
    history,
    { redirect, minAge, maxAge }
) {
    let url = `/login?success-redirect=${encodeURIComponent(redirect)}`
    if (minAge) url += `&min-age=${minAge}`
    if (maxAge) url += `&max-age=${maxAge}`
    history.push(url)
}

export function getIsFemaleFromFiscalCode(code) {
    const codeParser = new CodeParser(code)

    return codeParser.gender === "F"
}
